import { ESRQuestionConfig } from "./types/data";

export function parseFileIds(response: string): string[] {
	if (!response) return [];
	try {
		const parsed = JSON.parse(response);
		if (Array.isArray(parsed)) return parsed;
	} catch {}
	return [response];
}

function pad<T>(arr: Array<T | null>, toSize: number): Array<T | null> {
	while (arr.length < toSize) {
		arr.push(null);
	}
	return arr;
}

export function isFullWidth(q: ESRQuestionConfig) {
	return q.field_type.startsWith("list") || q.field_type === "map";
}

export function splitQuestionsIntoRows(
	questions: ESRQuestionConfig[],
	rowSize: number,
): Array<Array<ESRQuestionConfig | null>> {
	const res: Array<Array<ESRQuestionConfig | null>> = [];
	let row: Array<ESRQuestionConfig | null> = [];

	for (const q of questions) {
		// (loop invariant) 0 <= row.length < rowSize
		if (isFullWidth(q)) {
			if (row.length) {
				res.push(pad(row, rowSize));
				row = [];
			}
			res.push([q]);
		} else {
			row.push(q);
			if (row.length === rowSize) {
				res.push(row);
				row = [];
			}
		}
	}
	// (loop invariant) 0 <= row.length < rowSize
	if (row.length) {
		res.push(pad(row, rowSize));
	}

	return res;
}
